import { Text } from '@/components/text';
import { StyleSheet, TextInput, View } from 'react-native';

export function TextInputField({
  label,
  value,
  placeholder,
  placeholderTextColor,
  onChangeText,
  disabled,
  maxLength,
  autoCapitalize = 'none',
  id,
  name,
}: {
  label: string;
  value: string;
  placeholder?: string;
  placeholderTextColor?: string;
  onChangeText: (v: string) => void;
  disabled?: boolean;
  maxLength?: number;
  autoCapitalize?: 'none' | 'characters' | 'words' | 'sentences';
  id?: string;
  name?: string;
}) {
  return (
    <View style={{ gap: 6 }}>
      <Text type='defaultSemiBold'>{label}</Text>

      <TextInput
        {...({ name } as any)}
        nativeID={id}
        value={value}
        onChangeText={onChangeText}
        placeholder={placeholder}
        placeholderTextColor={placeholderTextColor}
        editable={!disabled}
        maxLength={maxLength}
        autoCapitalize={autoCapitalize}
        style={[styles.input, disabled && styles.disabled]}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  input: {
    borderWidth: 1,
    borderColor: 'rgba(0,0,0,0.12)',
    borderRadius: 12,
    paddingHorizontal: 12,
    paddingVertical: 10,
    backgroundColor: '#fff',
    outlineStyle: 'none' as any, // web
  },
  disabled: { opacity: 0.6 },
});
